import "../css/style.css"
import {lazyLoading} from "./lazyload/lazyload-init"
import "../components/main-nav"
import "../components/main-header/main-header"
import "../components/main-header/main-header-search/main-header-search"
import "../components/items/menu-item/menu-item"
import {polyfill} from "smoothscroll-polyfill"
polyfill()

window.lazyloading = lazyLoading // add lazyloading to global window object

async function loadFancybox() {
  if (document.querySelectorAll("[data-fancybox]").length) {
    await import("./fancybox/fancybox")
  }
}
async function loadMain() {
  await import("./main")
  loadFancybox()
}
loadMain()

async function loadModals() {
  if (document.querySelectorAll(".c-modal").length) {
    await import("@components/modal/modal")
  }
}
loadModals()

async function loadFileInput() {
  if (document.querySelectorAll(".f-file").length) {
    await import("../components/fields/file-field/file-field")
  }
}
loadFileInput()

async function loadDateInput() {
  if (document.querySelectorAll(".f-date").length) {
    await import("../components/fields/date-field/date-field")
  }
}
loadDateInput()

async function loadPasswordField() {
  if (document.querySelectorAll(".f-text.--password").length) {
    await import("../components/fields/text-field/text-field--password")
  }
}
loadPasswordField()

async function loadTextField() {
  if (document.querySelectorAll(".f-text, .f-textarea, .f-date").length) {
    await import("../components/fields/text-field/text-field")
  }
}
loadTextField()

async function loadCalendar() {
  if (document.querySelectorAll(".s-calendar").length) {
    await import("../components/sections/calendar-section/calendar-section")
  }
}
loadCalendar()

async function loadSlimSelect() {
  if (document.querySelectorAll(".slim-select").length) {
    await import("./slim-select/slim-select")
  }
}
loadSlimSelect()

async function loadAlerts() {
  if (document.querySelectorAll(".i-alert").length) {
    await import("@components/items/alert-item/alert-item")
  }
}
loadAlerts()

async function loadNotification() {
  if (document.querySelectorAll(".i-notification").length) {
    await import("../components/items/notification-item/notification-item")
  }
}
loadNotification()

async function loadFaqItem() {
  if (document.querySelectorAll(".i-faq").length) {
    await import("@components/items/faq-item/faq-item")
  }
}
loadFaqItem()

async function loadSwiper() {
  if (document.querySelectorAll(".swiper").length) {
    await import("./swiper/swiper")
  }
}
loadSwiper()

async function loadCheckboxSelectField() {
  if (document.querySelectorAll(".f-checkbox-select").length) {
    await import("../components/fields/checkbox-select-field")
  }
}
loadCheckboxSelectField()

async function loadOverlayScrollbars() {
  if (document.querySelectorAll(".u-scrollbar").length) {
    await import("./overlayscrollbars")
  }
}
loadOverlayScrollbars()

async function loadBaseForm() {
  if (document.querySelectorAll("form.--validate").length) {
    await import("../components/base-form/base-form")
  }
}
loadBaseForm()

async function loadScrollUp() {
  if (document.querySelectorAll(".c-scroll-up").length) {
    await import("@components/scroll-up/scroll-up")
  }
}
loadScrollUp()

async function loadMoreVideos() {
  if (document.querySelectorAll(".g-videos-more").length) {
    await import("../components/groups/videos-more-group/videos-more-group")
  }
}
loadMoreVideos()

// Consultant profile "load more videos" (ported from zdroje with -c class renames)
async function loadMoreConsultantVideos() {
  if (document.querySelectorAll(".s-consultant-videos").length) {
    await import("../components/consultant/groups/videos-more-group/videos-more-group")
  }
}
loadMoreConsultantVideos()

async function loadConsultantUspsSameHeight() {
  if (document.querySelectorAll(".g-usps-c").length) {
    await import("../components/consultant/groups/usps-group/usps-group")
  }
}
loadConsultantUspsSameHeight()

async function loadUspsSameHeight() {
  if (document.querySelectorAll(".g-usps").length) {
    await import("../components/groups/usps-group/usps-group")
  }
}
loadUspsSameHeight()

async function loadTabs() {
  if (document.querySelectorAll(".js-tabs").length) {
    await import("../components/tab-panel/tab-panel")
  }
}
loadTabs()

async function loadTeamFiltration() {
  if (document.querySelectorAll(".s-person-filter").length) {
    await import("./team-filtration/team-filtration")
  }
}

loadTeamFiltration()

async function loadDataLayerInteraction() {
  if (document.querySelectorAll("form[data-datalayer-event]").length) {
    await import("../components/base-form/datalayer-interaction")
  }
}
loadDataLayerInteraction()

async function loadRecaptcha() {
  if (document.querySelectorAll("form[data-recaptcha-action]").length) {
    await import("./recaptcha/recaptcha")
  }
}
loadRecaptcha()
